<template>
  <div class="my-contact-info-container">
    <section class="header-container">
      <div class="header-text-icon-container">
        <div class="text-container">
          <div class="header-text">My contact info</div>
          <div class="header-des">
            This helps the dealership get in touch with you
          </div>
        </div>
        <img
          v-if="!isSaveButtonVisible"
          class="chevron-left-icon"
          loading="lazy"
          alt=""
          src="../../assets/chevronleft.svg"
          @click="goBack"
        />
        <button
          v-if="isSaveButtonVisible"
          type="button"
          @click="updateForm"
          class="solid-button p-med-semibold"
        >
          Save
        </button>
      </div>
    </section>
    <img
      class="separator-icon"
      loading="lazy"
      alt=""
      src="../../assets/separator.svg"
    />
    <form style="width: 100%">
      <section class="input-field-container">
        <div class="text-input-field">
          <div class="label-frame">
            <div class="input-label">Email</div>
            <div
              class="input-container"
              :style="{
                border: isEmailTouched
                  ? '3px solid #3B3B3B'
                  : '1px solid #3B3B3B',
              }"
              @click="validateEmail"
            >
              <input
                class="user-input-field"
                placeholder="abc@def.gh"
                type="text"
                v-model="email"
                @keyup="validateEmail"
              />
              <img
                v-if="email"
                class="x-icon"
                alt=""
                src="../../assets/x-cercle.svg"
                @click="clearInput('email')"
              />
            </div>
            <div
              class="error-message"
              v-if="email && !isEmailValid && isEmailTouched"
            >
              Invalid email format
            </div>
            <div class="error-message" v-if="!email && isEmailTouched">
              Email is required
            </div>
          </div>
        </div>
        <div class="text-input-field">
          <div class="label-frame">
            <div class="input-label">Phone number</div>
            <div
              class="input-container"
              :style="{
                border: isPhoneTouched
                  ? '3px solid #3B3B3B'
                  : '1px solid #3B3B3B',
              }"
              @click="validatePhone"
            >
              <input
                class="user-input-field"
                placeholder="Enter phone number"
                type="text"
                v-model="phone"
                @keyup="validatePhone"
              />
              <img
                v-if="phone"
                class="x-icon"
                alt=""
                src="../../assets/x-cercle.svg"
                @click="clearInput('phone')"
              />
            </div>
            <div class="error-message" v-if="!phone && isPhoneTouched">
              Phone is required
            </div>
          </div>
        </div>
      </section>
    </form>
  </div>
</template>
<script setup>
import { computed, onUnmounted, ref, watch } from "vue";
import { useLeadStore } from "@/stores/useLeadStore";
import { storeToRefs } from "pinia";

const email = ref("");
const phone = ref("");
const isEmailValid = ref(true);
const isEmailTouched = ref(false);
const isPhoneTouched = ref(false);

const leadStore = useLeadStore();
const { lead } = storeToRefs(leadStore);

const hideDetailsEmit = defineEmits(["hide-details"]);

const stopWatching = watch(
  lead,
  (newValue) => {
    console.log(newValue.email, "newValue.email");
    email.value = newValue.email;
    phone.value = newValue.phone;
  },
  { deep: true }
);

const validateEmail = () => {
  isEmailTouched.value = true;
  // Regular expression to validate email format
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  isEmailValid.value = emailRegex.test(email.value);
};

const validatePhone = () => {
  isPhoneTouched.value = true;
};

const isSaveButtonVisible = computed(() => {
  return isEmailValid.value && phone.value;
});

const goBack = () => {
  hideDetailsEmit("hide-details");
};

const updateForm = () => {
  console.log(email.value, phone.value);
  // updateContactInfo(email.value, phone.value)
  // saveContactInfo(email.value, phone.value)
};

const clearInput = (fieldName) => {
  if (fieldName === "email") {
    email.value = "";
  } else {
    phone.value = "";
  }
};

onUnmounted(() => {
  stopWatching();
});
</script>
<style scoped>

.chevron-left-icon {
  height: 48px;
  width: 48px;
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
  cursor: pointer;
  margin: 0rem -1.1rem 0rem 0rem;
}

.separator-icon {
  align-self: stretch;
  /* height: 1px; */
  position: relative;
  width: 100%;
  overflow: hidden;
  flex-shrink: 0;
}
.x-icon {
  height: 48px;
  width: 48px;
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
}

.error-message {
  position: relative;
  font-size: var(--paragraph-primary-medium-regular-size);
  line-height: 21px;
  color: var(--negative-default);
}

.my-contact-info-container {
  width: 100%;
  background-color: var(--white-default);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  /* padding: 0px var(--padding-5xl); */
  box-sizing: border-box;
  gap: 1.25rem;
  /* min-height: 715px; */
  z-index: 3;
}

.header-container {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: var(--padding-11xl) 0px 0px;
  text-align: left;
  font-size: var(--paragraph-secondary-large-regular-size);
  color: var(--black-default);
  font-family: var(--paragraph-primary-medium-regular);
}

.header-text-icon-container {
  border-radius: var(--br-9xs) 0px 0px var(--br-9xs);
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  /* padding: 0px var(--padding-9xs) 0px var(--padding-4xl-5); */
  width: 100%;
  padding: 0px 0px 0px 0px;
  box-sizing: border-box;
}

.text-container {
  width: 239px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: var(--padding-12xs) 0px;
  gap: 5px;

  .header-text {
    position: relative;
    letter-spacing: 0.01em;
    line-height: 27px;
    font-weight: 600;
    font-size: 16px;
    text-align: left;
  }
  .header-des {
    align-self: stretch;
    position: relative;
    font-size: var(--font-size-mini);
    line-height: 22px;
    font-weight: 400;
    letter-spacing: 0em;
    text-align: left;
    color: #808080;
  }
}

.input-field-container {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 30px;
  text-align: left;
  font-size: var(--paragraph-secondary-large-regular-size);
  color: var(--black-default);
  font-family: var(--paragraph-primary-medium-regular);

  .text-input-field {
    align-self: stretch;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    cursor: pointer;

    .label-frame {
      align-self: stretch;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      gap: 10px;

      .input-label {
        align-self: stretch;
        position: relative;
        letter-spacing: 0.01em;
        line-height: 23px;
        font-weight: 500;
        font-size: 16px;
        text-align: left;
        color: var(--black-default);
      }

      .input-container {
        align-self: stretch;
        height: 58px;
        border-radius: var(--br-9xs);
        border: 1px solid var(--black-default);
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        padding: var(--padding-8xs) var(--padding-11xs) var(--padding-8xs)
          var(--padding-smi);
        gap: 15px;

        .user-input-field {
          width: 100%;
          border: none;
          outline: none;
          background-color: transparent;
          height: 23px;
          flex: 1;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: flex-start;
          font-size: var(--paragraph-primary-large-medium-size);
          color: var(--black-default);
          min-width: 212px;

          font-weight: 400;
          line-height: 23px;
          letter-spacing: 0.01em;
          text-align: left;
        }
      }
    }
  }
}
</style>
